import { render, staticRenderFns } from "./TransactionDetailsForm.vue?vue&type=template&id=0461cf58&"
import script from "./TransactionDetailsForm.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports